import { ExclamationCircleFilled, InfoCircleOutlined } from "@ant-design/icons";
import {
  Alert,
  Avatar,
  Button,
  Divider,
  Form,
  Input,
  message,
  Modal,
  Select,
  Space,
  Spin,
  Tooltip,
  Typography,
} from "antd";
import CreateDiary from "assets/images/create-diary.png";
import User from "models/user/user";
import NetworkCall from "network/networkCall";
import Request from "network/request";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";

import {
  allDiaries,
  arciveDiaries,
  saveCurrentDiary,
  saveDiaryStatus,
  saveNewlyCreatedDiary,
} from "redux/diaries/diariesSlice";
import Loader from "utilities/loader";
import {
  leadingSpaces,
  leadingSpacesforRelation,
  onlyAlphabets,
} from "utilities/regexUtilities";
import { DiaryStatusRoutes, downloadEvent } from "utilities/generalUtility";
const { Title } = Typography;

export default function CreateDiaryModal({ setIsModalOpen, isModalOpen }) {
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [newDiary, setNewDiary] = useState({
    therapistDiary: false,
    coDiaristDiary: false,
  });
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();

  const [isError, setIsError] = useState({ status: false, message: "" });
  const [isErrorSub, setIsErrorSub] = useState({ status: false, message: "" });
  const dispatch = useDispatch();
  const [dropdownLoader, setdropdownLoader] = useState(false);
  const [relationship, setRelationship] = useState([]);
  const [topic, setTopic] = useState([]);
  const [relationName, setRelationName] = useState("");
  const [subName, setSubName] = useState("");
  const [addLoader, setAddLoader] = useState(false);
  const [inviteLoader, setInviteLoader] = useState(false);
  const [relationField, setrelationField] = useState(false);
  const [topicField, settopicField] = useState(false);
  const [disabledFields, setdisabledFields] = useState(true);
  const [selectedType, setSelectedType] = useState();

  const [dropdownOpener1, setDropdownOpener1] = useState(false);
  const [dropdownOpener2, setDropdownOpener2] = useState(false);
  const [dropdownOpener3, setDropdownOpener3] = useState(false);
  const [dropdownOpener4, setDropdownOpener4] = useState(false);

  const isActive = User.isUserctive();
  const [btnLoading, setBtnLoading] = useState(false);
  const typeRef = useRef(null);
  const relation1Ref = useRef(null);
  const relation2Ref = useRef(null);

  const subRef = useRef(null);
  const diaries = useSelector(allDiaries);
  const archiveDiaries = useSelector(arciveDiaries);

  const [relationshipType, setRelationshipType] = useState([]);

  const [errorType, setErrorType] = useState({
    type: 0,
    message: "",
    diaryId: 0,
  });
  let diaryId = null;

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const onRelationNameChange = (event) => {
    setRelationName(event.target.value);
  };

  const errorHandler = (error) => {
    setErrorType({
      type: error?.error?.data?.data?.type,
      message: error?.error?.data?.message,
      diaryId: error?.error?.data?.data?.diaryId,
    });
  };
  const handleOk = () => {
    setNewDiary((prev) => {
      return { ...prev, coDiaristDiary: false, therapistDiary: false };
    });
    setIsModalOpen(false);
    form.resetFields();
  };
  const handleCancel = () => {
    setNewDiary((prev) => {
      return { ...prev, coDiaristDiary: false, therapistDiary: false };
    });
    setIsModalOpen(false);
    setErrorType({
      type: 0,
      message: "",
      diaryId: 0,
    });
    form.resetFields();
  };

  const handleFinish = async (values) => {
    try {
      setInviteLoader(true);
      values.roleType = 2;

      const response = await NetworkCall.fetch(Request.createNewDiary(values));
      message.success(response.message);
      setInviteLoader(false);
      dispatch(saveNewlyCreatedDiary(response?.data?.diary));
      dispatch(saveDiaryStatus({ diary: response?.data?.diary }));
      dispatch(
        saveCurrentDiary({
          diaryId: response?.data?.diary?.diaryId,
          topicId: response?.data?.diary?.topics[0]?.id,
          topicName: response?.data?.diary?.topics[0]?.name,
        })
      );
      const params = `?diaryId=${response?.data?.diary?.diaryId}&diaryTopicId=${response?.data?.diary?.topics[0]?.id}`;

      navigate(`/journal-request${params}`);
      setIsModalOpen(false);
      form.resetFields();
    } catch (error) {
      if (error?.error?.data?.data?.diaryId) {
        diaryId = error.error.data.data.diaryId;
      }
      (error.statusCode === 400 || error.statusCode === 403) &&
        errorHandler(error);
      setInviteLoader(false);
    }
  };

  const addRelationship = async (field) => {
    try {
      const body = {
        type: 2,
        name: relationName,
        relationshipType: selectedType,
      };
      setAddLoader(true);
      const check = relationship.filter(
        (e) =>
          e?.name?.toLowerCase()?.trim() ===
            relationName?.toLowerCase()?.trim() &&
          e?.relationshipType === selectedType
      );
      if (check?.length === 0) {
        const response = await NetworkCall.fetch(Request.AddType(body), false);
        message.success(response.message);

        setRelationship([
          {
            name: response?.data?.name,
            relationshipId: response?.data?.id,
            relationshipType: selectedType,
          },
          ...relationship,
        ]);
        field === 1
          ? form.setFieldsValue({ creatorRelationshipId: response?.data?.id })
          : form.setFieldsValue({ receiverRelationshipId: response?.data?.id });
      } else {
        field === 1
          ? form.setFieldsValue({
              creatorRelationshipId: check[0]?.relationshipId,
            })
          : form.setFieldsValue({
              receiverRelationshipId: check[0]?.relationshipId,
            });
      }
      field === 1
        ? form1.setFieldsValue({ relationshipName: null })
        : form3.setFieldsValue({ relationshipName: null });
      setIsError((prev) => {
        return {
          ...prev,
          status: false,
          message: "",
        };
      });
      setAddLoader(false);

      setDropdownOpener3(false);
      setDropdownOpener4(false);
    } catch (error) {
      setAddLoader(false);

      setIsError((prev) => {
        return {
          ...prev,
          status: true,
          message: error.message,
        };
      });
    }
  };

  const addTopic = async () => {
    try {
      const body = {
        type: 1,
        name: subName,
      };
      setAddLoader(true);
      const check = topic.filter(
        (e) => e?.name?.toLowerCase()?.trim() === subName?.toLowerCase()?.trim()
      );
      if (check.length === 0) {
        const response = await NetworkCall.fetch(Request.AddType(body), false);
        setTopic([
          { topicId: response?.data?.id, name: response?.data?.name },
          ...topic,
        ]);

        setSubName("");
        message.success(response.message);

        form.setFieldsValue({ topicId: response?.data?.id });
      } else {
        form.setFieldsValue({ topicId: check[0]?.topicId });
      }
      setAddLoader(false);
      setDropdownOpener2(false);
      form2.setFieldsValue({ subrelationshipName: null });
    } catch (error) {
      setAddLoader(false);

      setIsErrorSub((prev) => {
        return {
          ...prev,
          status: true,
          message: error.message,
        };
      });
    }
  };

  const onSubRelationNameChange = (event) => {
    setSubName(event.target.value);
  };
  // const setCoDiaristValue = () => {
  //   setNewDiary((prev) => {
  //     return { ...prev, coDiaristDiary: true, therapistDiary: false };
  //   });
  // };
  // const setTherapistValue = () => {
  //   setNewDiary((prev) => {
  //     return { ...prev, coDiaristDiary: false, therapistDiary: true };
  //   });
  // };
  const getRelationshipType = async () => {
    try {
      const type = await NetworkCall.fetch(
        Request.getRelationshipType(),
        false
      );
      setRelationshipType(type?.data?.tableListing);
      const response = await NetworkCall.fetch(
        Request.getAllRelationship(),
        false
      );
      const newData = response.data?.tableListing;
      setRelationship(newData);
    } catch (error) {
      setAddLoader(false);
    }
  };
  const getAllGlobalTopics = async () => {
    const data = await User.getAllTopics();
    setTopic(data?.data?.tableListing);
  };
  const handleRelationshipType = (event) => {
    setSelectedType(event);
    typeRef.current.blur();
    setdisabledFields(false);
  };

  // const handleRelKey = (e) => {
  //   if (e.keyCode === 13) {
  //     addRelationship();
  //   }
  // };

  // const handleSubKey = (e) => {
  //   if (e.keyCode === 13) {
  //     addTopic();
  //   }
  // };

  useEffect(() => {
    isActive && getRelationshipType();
    isActive && getAllGlobalTopics();
  }, []);

  useEffect(() => {
    if (isModalOpen && newDiary.coDiaristDiary) {
      const labels = document.getElementsByTagName("label");
      for (let i = 0; i < labels.length; i++) {
        labels[i].setAttribute("title", "");
      }
    }
  }, [newDiary.coDiaristDiary]);

  const sendReminderEmail = async () => {
    try {
      setBtnLoading(true);
      const response = await NetworkCall.fetch(
        Request.sendReminderEmail(errorType?.diaryId)
      );
      message.success(response.message);
      setBtnLoading(false);

      setErrorType({
        type: 0,
        message: "",
        diaryId: 0,
      });
      form.resetFields();
    } catch (error) {
      message.error(error.message);
      setBtnLoading(false);

      // setFieldErrorsFromServer(error, form, values);
    }
  };

  const redirect = async (diaryId) => {
    if (diaryId) {
      const check = diaries?.findIndex((e) => e?.diaryId === parseInt(diaryId));
      const flag = check === -1;
      const diary = (flag ? archiveDiaries : diaries).find(
        (e) => e?.diaryId === diaryId
      );
      dispatch(saveDiaryStatus({ diary }));
      dispatch(
        saveCurrentDiary({
          diaryId: diary?.diaryId,
          topicId: diary?.topics[0]?.id,
          topicName: diary?.topics[0]?.name,
        })
      );
      const params = `?diaryId=${diary?.diaryId}&diaryTopicId=${
        diary?.topics[0]?.id
      }${
        check === -1
          ? "&archivedNotification=true"
          : "&archivedNotification=false"
      }`;

      navigate(
        `${DiaryStatusRoutes[diary?.status?.id] ?? "/journal-request"}${params}`
      );

      setIsModalOpen(false);
      form.resetFields();
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  const [loading] = useState(false);
  return (
    <>
      <Modal
        className="create-diary-modal cm-modal "
        centered
        destroyOnClose={true}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        closeIcon={<i className="icon-close"></i>}
        footer={null}
      >
        <div className="diary-modal-header">
          <img src={CreateDiary} alt="" />
          <div>
            <Title level={2}>Who are you inviting ?</Title>
          </div>
        </div>
        <Divider />

        <Spin spinning={inviteLoader}>
          {/* {errorType.type === 6 && (
            <Alert
              className="decline-alert"
              description={errorType.message}
              type="error"
            />
          )} */}
          {errorType.type === 4 && (
            <Alert
              className="decline-alert"
              message={errorType.message}
              type="error"
            />
          )}
          {(errorType.type === 1 || errorType.type === 5) && (
            <Alert
              // className="already-diary-alert"
              className="diary-request-alert"
              message={errorType.message}
              type="error"
              action={
                <Button
                  size="small"
                  onClick={() => {
                    redirect(errorType?.diaryId);
                  }}
                >
                  Click Here
                </Button>
              }
            />
          )}

          {errorType.type === 3 && (
            <Alert
              className="reminder-alert"
              message={errorType.message}
              action={
                <Space>
                  <Button
                    size="small"
                    className="btn-yes"
                    onClick={sendReminderEmail}
                    loading={btnLoading}
                  >
                    Yes
                  </Button>
                  <Button
                    size="small"
                    className="btn-no"
                    onClick={() => {
                      setErrorType({
                        type: 0,
                        message: "",
                        diaryId: 0,
                      });
                      form.resetFields();
                    }}
                  >
                    No
                  </Button>
                </Space>
              }
            />
          )}
          <Form
            className="create-diary-form"
            onFinish={handleFinish}
            form={form}
          >
            <Form.Item
              colon={false}
              label="First Name"
              name="firstName"
              rules={[
                {
                  required: true,
                  message: "Please input First Name",
                },
                {
                  max: 15,
                  message: "First Name must be less than 15",
                },
                {
                  pattern: new RegExp(onlyAlphabets),
                  message:
                    "Field does not accept numbers,special chracters or spaces",
                },
              ]}
            >
              <Input
                //  maxLength={25}
                placeholder="First Name"
                ref={inputRef}
              />
            </Form.Item>
            <Form.Item
              colon={false}
              label="Last Name"
              name="lastName"
              rules={[
                {
                  required: true,
                  message: "Please input Last Name",
                },
                {
                  max: 15,
                  message: "Last Name must be less than 15",
                },
                {
                  pattern: new RegExp(onlyAlphabets),
                  message:
                    "Field does not accept numbers,special chracters or spaces",
                },
              ]}
            >
              <Input
                //  maxLength={25}
                placeholder="Last Name"
              />
            </Form.Item>
            <Form.Item
              colon={false}
              label="Email"
              hasFeedback
              name="email"
              rules={[
                {
                  type: "email",
                  message: "The Input is not valid Email",
                },
                {
                  required: true,
                  message: "Please input your Email",
                },
              ]}
            >
              <Input placeholder="Email ID" type="email" />
            </Form.Item>
            <Form.Item
              colon={false}
              label="Relationship Type"
              name="relationshipType"
              rules={[
                {
                  required: true,
                  message: "Please select Relationship Type",
                },
              ]}
            >
              <Select
                ref={typeRef}
                onSelect={(e) => {
                  handleRelationshipType(e);
                }}
                onFocus={() => {
                  setDropdownOpener1(true);
                }}
                open={dropdownOpener1}
                onDropdownVisibleChange={(op) => {
                  setDropdownOpener1(op);
                }}
                suffixIcon={
                  <i className="icon-arrow-down site-form-item-icon text-primary"></i>
                }
                className="relationship-select"
                getPopupContainer={(triggerNode) => {
                  return triggerNode.parentNode;
                }}
                popupClassName="relationship-select-dropdown"
                placeholder="Select Relationship Type"
                options={relationshipType.map((item) => ({
                  label: item.name,
                  value: item.id,
                }))}
              />
            </Form.Item>
            <Form.Item
              colon={false}
              className="position-filed"
              // tooltip={{
              //   overlayClassName: "custom-tooltip",
              //   placement: "bottom",
              //   arrowPointAtCenter: "True",
              //   title: "Your Position in Relationship",
              //   icon: <InfoCircleOutlined />,
              // }}
              label="Your Position in Relationship"
              name="creatorRelationshipId"
              rules={[
                {
                  required: true,
                  message: "Please select Relationship Type",
                },
              ]}
            >
              {/* <Tooltip
                title={disabledFields ? "Please Select Relationship Type" : ""}
              > */}
              <Select
                disabled={disabledFields}
                ref={relation1Ref}
                showSearch
                onSelect={() => {
                  relation1Ref.current.blur();
                }}
                onFocus={() => {
                  setDropdownOpener3(true);
                }}
                open={dropdownOpener3}
                onDropdownVisibleChange={(op) => {
                  setDropdownOpener3(op);
                }}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                suffixIcon={
                  <i className="icon-arrow-down site-form-item-icon text-primary"></i>
                }
                className="relationship-select"
                getPopupContainer={(triggerNode) => {
                  return triggerNode.parentNode;
                }}
                popupClassName="relationship-select-dropdown"
                placeholder="Select your relationship"
                dropdownRender={(menu) => (
                  <>
                    {dropdownLoader ? (
                      <Loader />
                    ) : (
                      <>
                        {menu}{" "}
                        {relationField ? (
                          <Button
                            type="text"
                            icon={<PlusOutlined />}
                            onClick={() => {
                              setrelationField(false);
                            }}
                          >
                            Other
                          </Button>
                        ) : (
                          <Form
                            layout="horizontal"
                            form={form1}
                            onFinish={() => addRelationship(1)}
                            className="rel-dropdown"
                          >
                            <Form.Item
                              label="Other Relationship"
                              name="relationshipName"
                              className="relationship-name"
                              rules={[
                                {
                                  required: true,
                                  message: "Relationship name is required",
                                },
                                {
                                  max: 25,
                                  message: "Relationship must be less than 25",
                                },
                                {
                                  pattern: new RegExp(leadingSpacesforRelation),
                                  message:
                                    "Name must have 3 characters and without leading spaces",
                                },
                              ]}
                            >
                              <Input
                                onClick={(e) => e.stopPropagation()}
                                placeholder="Add relationship"
                                value={relationName}
                                onChange={onRelationNameChange}
                                // onKeyUp={handleRelKey}
                              />
                            </Form.Item>
                            {isError.status && (
                              <Alert
                                className="custom-alert"
                                message={isError.message}
                                showIcon
                                icon={<ExclamationCircleFilled />}
                              />
                            )}
                            <Form.Item className="mb-0 text-right">
                              <Button
                                key="add"
                                type="primary"
                                loading={addLoader}
                                htmlType="submit"
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                              >
                                Add
                              </Button>
                            </Form.Item>
                          </Form>
                        )}
                      </>
                    )}
                  </>
                )}
                options={relationship
                  // .filter((e) =>
                  //   e?.relationshipName
                  //     ?.toLowerCase()
                  //     .includes(relationName?.toLowerCase())
                  // )
                  .filter((e) => e?.relationshipType === selectedType)
                  .map((item) => ({
                    label: item.name,
                    value: item.relationshipId,
                  }))}
              />
              {/* </Tooltip> */}
            </Form.Item>

            <Form.Item
              colon={false}
              className="position-filed"
              // tooltip={{
              //   overlayClassName: "custom-tooltip",
              //   placement: "bottom",
              //   arrowPointAtCenter: "True",
              //   title: "Other Person Position in Relationship",
              //   icon: <InfoCircleOutlined />,
              // }}
              label="Other Person Position in Relationship"
              name="receiverRelationshipId"
              rules={[
                {
                  required: true,
                  message: "Please select Relationship Type",
                },
              ]}
            >
              {/* <Tooltip
                title={disabledFields ? "Please Select Relationship Type" : ""}
              > */}
              <Select
                disabled={disabledFields}
                ref={relation2Ref}
                showSearch
                onSelect={() => {
                  relation2Ref.current.blur();
                }}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onFocus={() => {
                  setDropdownOpener4(true);
                }}
                open={dropdownOpener4}
                onDropdownVisibleChange={(op) => {
                  setDropdownOpener4(op);
                }}
                suffixIcon={
                  <i className="icon-arrow-down site-form-item-icon text-primary"></i>
                }
                className="relationship-select"
                getPopupContainer={(triggerNode) => {
                  return triggerNode.parentNode;
                }}
                popupClassName="relationship-select-dropdown"
                placeholder="Select other person relationship "
                dropdownRender={(menu) => (
                  <>
                    {dropdownLoader ? (
                      <Loader />
                    ) : (
                      <>
                        {menu}{" "}
                        {relationField ? (
                          <Button
                            type="text"
                            icon={<PlusOutlined />}
                            onClick={() => {
                              setrelationField(false);
                            }}
                          >
                            Other
                          </Button>
                        ) : (
                          <Form
                            layout="horizontal"
                            form={form3}
                            onFinish={() => addRelationship(2)}
                            className="rel-dropdown"
                          >
                            <Form.Item
                              label="Other Relationship"
                              name="relationshipName"
                              className="relationship-name"
                              rules={[
                                {
                                  required: true,
                                  message: "Relationship name is required",
                                },
                                {
                                  max: 25,
                                  message: "Relationship must be less than 25",
                                },
                                {
                                  pattern: new RegExp(leadingSpacesforRelation),
                                  message:
                                    "Name must have 3 characters and without leading spaces",
                                },
                              ]}
                            >
                              <Input
                                onClick={(e) => e.stopPropagation()}
                                placeholder="Add relationship"
                                value={relationName}
                                onChange={onRelationNameChange}
                                // onKeyUp={handleRelKey}
                              />
                            </Form.Item>
                            {isError.status && (
                              <Alert
                                className="custom-alert"
                                message={isError.message}
                                showIcon
                                icon={<ExclamationCircleFilled />}
                              />
                            )}
                            <Form.Item className="mb-0 text-right">
                              <Button
                                key="add"
                                type="primary"
                                loading={addLoader}
                                htmlType="submit"
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                              >
                                Add
                              </Button>
                            </Form.Item>
                          </Form>
                        )}
                      </>
                    )}
                  </>
                )}
                options={relationship
                  // .filter((e) =>
                  //   e?.relationshipName
                  //     ?.toLowerCase()
                  //     .includes(relationName?.toLowerCase())
                  // )
                  .filter((e) => e?.relationshipType === selectedType)
                  .map((item) => ({
                    label: item.name,
                    value: item.relationshipId,
                  }))}
              />
              {/* </Tooltip> */}
            </Form.Item>
            <Form.Item
              className="mb-0"
              colon={false}
              label="Select Topic"
              name="topicId"
              rules={[
                {
                  required: true,
                  message: "Please select Topic",
                },
              ]}
            >
              <Select
                ref={subRef}
                onSelect={() => {
                  subRef.current.blur();
                }}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onFocus={() => {
                  setDropdownOpener2(true);
                }}
                showSearch
                open={dropdownOpener2}
                onDropdownVisibleChange={(op) => {
                  setDropdownOpener2(op);
                }}
                suffixIcon={
                  <i className="icon-arrow-down site-form-item-icon text-primary"></i>
                }
                getPopupContainer={(triggerNode) => {
                  return triggerNode.parentNode;
                }}
                // defaultValue="Select"
                className="relationship-select"
                popupClassName="relationship-select-dropdown"
                placeholder="Select Topic"
                dropdownRender={(menu) => (
                  <>
                    {dropdownLoader ? (
                      <Loader />
                    ) : (
                      <>
                        {menu}
                        {topicField ? (
                          <Button
                            type="text"
                            icon={<PlusOutlined />}
                            onClick={() => {
                              setrelationField(false);
                            }}
                          >
                            Other
                          </Button>
                        ) : (
                          <Form
                            layout="horizontal"
                            form={form2}
                            onFinish={addTopic}
                            className="rel-dropdown"
                          >
                            <Form.Item
                              label="Other Topic"
                              name="subrelationshipName"
                              className="relationship-name"
                              rules={[
                                {
                                  required: true,
                                  message: "Topic name is required",
                                },
                                {
                                  max: 45,
                                  message: "Topic must be less than 45",
                                },
                                {
                                  pattern: new RegExp(leadingSpaces),
                                  message:
                                    "Topic name must have 5 characters and does not accept leading spaces",
                                },
                              ]}
                            >
                              <Input
                                onClick={(e) => e.stopPropagation()}
                                placeholder="Add topic"
                                value={subName}
                                onChange={onSubRelationNameChange}
                              />
                            </Form.Item>
                            {isErrorSub.status && (
                              <Alert
                                className="custom-alert"
                                message={isErrorSub.message}
                                showIcon
                                icon={<ExclamationCircleFilled />}
                              />
                            )}
                            <Form.Item className="mb-0 text-right">
                              <Button
                                key="addS"
                                type="primary"
                                loading={addLoader}
                                htmlType="submit"
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                                // onClick={form2.submit}
                              >
                                Add
                              </Button>
                            </Form.Item>
                          </Form>
                        )}
                      </>
                    )}
                  </>
                )}
                options={topic
                  // .filter((e) =>
                  //   e?.name?.toLowerCase().includes(subName?.toLowerCase())
                  // )
                  .map((item) => ({
                    label: item.name,
                    value: item.topicId,
                  }))}
              />
            </Form.Item>
            <div className="custom-footer-btns">
              <Form.Item className="mb-0">
                <Button
                  key="submit"
                  htmlType="submit"
                  type="primary"
                  loading={loading}
                  onClick={() => {
                    downloadEvent("JournalInvite");
                  }}
                >
                  Send Invite
                </Button>
              </Form.Item>
              <Form.Item className="mb-0">
                <Button ghost key="back" onClick={handleCancel}>
                  Cancel
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Spin>
      </Modal>
    </>
  );
}
